export const AWS_S3_BUCKET = process.env.REACT_APP_AWS_S3_BUCKET || "";
export const AWS_S3_BASE_URL = process.env.REACT_APP_AWS_S3_URL || "";
export const CONTRACT_PATH = "images/contracts/${contractId}/$fileName";
export const PROFILE_PATH = "images/users/${userId}/$fileName";
export const REACT_APP_AWS_ACCESS_KEY_ID =
  process.env.REACT_APP_AWS_ACCESS_KEY_ID;
